// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  display: block;
  box-sizing: padding-box;
  overflow: hidden;
}

.file-input {
  display: none;
}

.kanban {
  padding-top: 20px;
  padding-right: 30px;
  padding-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/components/dialog/dialog-body-task/dialog-body-task.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,uBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AACE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ","sourcesContent":["textarea{  \r\n    display: block;\r\n    box-sizing: padding-box;\r\n    overflow: hidden;  \r\n}\r\n\r\n.file-input {\r\n    display: none;\r\n  }\r\n  .kanban{\r\n    padding-top: 20px;\r\n    padding-right: 30px;\r\n    padding-left: 30px ;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
